import { IconType, SvgIcon } from './SvgIcon';

export const PauseIcon: IconType = (props) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 20 20">
    <path
      d="M13.667 3V16H11.5V3H13.667Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16699 3V16H6V3H8.16699Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

PauseIcon.displayName = 'PauseIcon';
